import { Component, OnInit, OnDestroy, ViewContainerRef } from '@angular/core';
import { ITdDataTableColumn, TdDataTableService, TdLoadingService, TdDialogService } from '@covalent/core';
import { CustomerService } from '../../accounting/customer/customer.service';
import { Location } from '@angular/common';
import { DebitNote } from '../debit-note';
import { Subscription } from 'rxjs/Subscription';
import { Branch } from '../../accounting/branch';
import { Customer } from '../../accounting/customer';
import { SalesService } from '../sales.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { PoService } from '../../purchasing/pos/po.service';
import { ReportService } from '../../../shared/services/report.service';
import { InventoryService } from '../../inventory/inventory.service';
import { SettingsService } from '../../../shared/services/settings.service';
import { BranchService } from '../../accounting/branches/branch.service';
import { Observable } from '../../../../../node_modules/rxjs/Observable';
import { InvoiceService } from '../../../shared/services/invoice.service';

@Component({
  selector: 'app-debit-note',
  templateUrl: './debit-note.component.html',
  styleUrls: ['./debit-note.component.scss'],
  providers: [CustomerService, ReportService, InvoiceService]
})
export class DebitNoteComponent implements OnInit, OnDestroy {
  _loading: number = 0;

  item: any = {};

  currentDebitNote: DebitNote = new DebitNote();
  originalDebitNote: DebitNote = new DebitNote();

  valid_salesmen: string[] = [];

  subscription: Subscription = new Subscription();
  title: string;

  allBranches: Branch[];
  filteredBranches: Branch[];

  selectedCustomer: Customer;
  cust: any;

  allCustomers: Customer[] = [];
  matchingCustomers: Customer[] = [];

  availableStatuses: string[];

  _currency_symbol: string;

  isEditMode: boolean;

  items: any[] = [];

  filteredData: any[] = [];

  need_invoice: boolean = false;

  columns: ITdDataTableColumn[] = [
    { name: 'collection', label: 'Collection', tooltip: 'some tooltip example' },
    { name: 'designColor', label: 'Design / Color' },
    { name: 'pieceNo', label: 'Piece #' },
    { name: 'lotNo', label: 'Lot #' },
    { name: 'quantity', label: 'QTY (M)' },
    { name: 'unit_price', label: 'Unit Price' },
  ];

  constructor(private _salesService: SalesService,
    private _customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router,
    private _dataTableService: TdDataTableService,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _settingsService: SettingsService,
    private _invoiceService: InvoiceService,
    private _viewContainerRef: ViewContainerRef,
    private _branchService: BranchService,
    private _inventoryService: InventoryService,
    private _reportService: ReportService,
    private _poService: PoService,
    private location: Location,
    public _authService: AuthenticationService) { }



  ngOnInit() {

    this.setLoading(true, 'loading');

    this.route.paramMap
      .switchMap((params: ParamMap) => params.get('id')
        ? this.processEditDebitNote(params.get('id'))
        : this.processNewDebitNote())
      .subscribe((currentItem: DebitNote) => {
        this.currentDebitNote = currentItem;
        // If it was an existing Sale retrieve items
        if (this.currentDebitNote.id != null) {
          this.title = this.currentDebitNote.order_number;

          this.originalDebitNote = Object.assign({}, this.currentDebitNote);
          this.cust = this.currentDebitNote.customer_prefix + ' - ' + this.currentDebitNote.customer_name;

          this._salesService.getDebitNoteItems(this.currentDebitNote.id + '').subscribe(
            response => {
              this.items = response;
              console.log(this.items)
            }
          );

          this.updateTax(this.currentDebitNote.branch_id, this.currentDebitNote.tax != null);
        } else {
          // This one's new. Set default branch on load
          this.currentDebitNote.branch_id = this._authService.getHomeBranch();
          // And its tax
          this.updateTax(this.currentDebitNote.branch_id);
          // load available customers
          this.loadCustomers();
        }

        // If the order was draft, we need invoice if we moved it to SHIPPED
        if (this.currentDebitNote.status == 'DRAFT') {
          this.need_invoice = true;
        }

        this.setLoading(false, 'loading');
        this.availableStatuses = this.getAvailableStatuses();

        this.filterSalesmen();
      }
      );


    this.availableStatuses = this.getAvailableStatuses();

    this.allBranches = this._authService.getUserBranches();
    this.filteredBranches = this.allBranches;
  }

  loadCustomers() {
    this.clearSelected();
    console.log('getting customers for branch: ' + this.currentDebitNote.branch_id);

    this.subscription.add(
      this._customerService
        .getCustomersPerBranch(this.currentDebitNote.branch_id + '').subscribe(
          (response: { id: string, customers: Customer[] }) => {
          this.allCustomers = response.customers;
          this.matchingCustomers = response.customers.slice(0, 100);
        })
    );
  }


  ngOnDestroy() {
    console.log('unsubscribing');

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


  setSelected(customer: Customer) {
    // set the customer
    this.selectedCustomer = customer;

    this.currentDebitNote.customer_id = Number.parseInt(customer.id);
    this.currentDebitNote.customer_name = customer.name;
    this.currentDebitNote.customer_prefix = customer.prefix;

    // set the salesman
    this.getSalesman(customer.id);
  }

  clearSelected() {
    this.selectedCustomer = null;
    this.cust = '';

    this.currentDebitNote.customer_id = null;
    this.currentDebitNote.customer_name = null;
    this.currentDebitNote.customer_prefix = null;

    this.currentDebitNote.salesman = null;
  }


  // Filter based on user input
  filter(input: string) {
    console.log('input: ' + input);

    this.currentDebitNote.branch_id

      this.matchingCustomers = this.allCustomers.filter(
        (cust: Customer) => {
          let full_name = cust.prefix + ' - ' + cust.name;
          return full_name.toLowerCase().includes(input.toLowerCase());
        }
      ).slice(0,100); // limit the matches to 100
  }



  filterSalesmen() {
    console.log(this.currentDebitNote.branch_id);
    this._salesService.getUsersPerBranch(this.currentDebitNote.branch_id + '').subscribe(
      response => {
        if (Array.isArray(response)) {
          this.valid_salesmen = response.map(i => i.first_name + ' ' + i.last_name);
        } else {
          this.valid_salesmen = [];
        }
      }
    );
  }


  filterBranches() {
    this._customerService.getOneCustomerBranches(this.currentDebitNote.customer_id + '').subscribe(
      (response: { id: string, branches: Branch[] }) => {
        this.filteredBranches = response.branches.filter(
          (b: Branch) => {
            b.id = Number.parseInt(b.id + '');
            return this.allBranches.some(
              (_b: Branch) => {
                return b.id == _b.id
              }
            )
          }
        );
      }
    );
  }

  setLoading(loading: boolean, name: string) {
    if (loading) {
      this._loadingService.register(name);
      this._loading++;
    }
    else {
      this._loadingService.resolve(name);
      this._loading--;
    }
  }

  isLoading(): boolean {
    return this._loading > 0;
  }


  updateTax($event, currency_only?: boolean) {
    this._branchService.getBranch($event).subscribe(
      response => {
        if (response.sales_tax != null && !currency_only) {
          this.currentDebitNote.tax = response.sales_tax;
        }
        // Update also the currency
        if (response.currency != null) {
          this._currency_symbol = response.currency;
        }
      }
    );
  }

  changed(): boolean {
    for (let prop in this.currentDebitNote) {
      if (this.currentDebitNote[prop] != this.originalDebitNote[prop]) {
        return true;
      }
    }

    return false;
  }

  getSalesman($event) {
    this._customerService.getOneCustomer($event).subscribe(
      response => {
        this.currentDebitNote.salesman = response.sales_person;
      }
    );
  }

  addItemsToOrder() {
    this.items.push(Object.assign({}, this.item));
    this.item = {};

    console.log(this.items)
  }

  total() {
    return this.items.reduce((a, b) => { return a + Number.parseFloat(b.price) }, 0)
  }

  removeItem(id: number) {
    this.items = this.items.filter(
      (t) => {
        if (t.id == id) {
          // Send it back to the queue
          //this.existingInventory.push(t);

          return false;
        } else {
          return true;
        }
      });

  }

  openModifyTax() {
    this._dialogService.openPrompt({
      message: 'Enter new VAT value',
      viewContainerRef: this._viewContainerRef,
      title: 'Modify value',
      value: this.currentDebitNote.tax + '',
      cancelButton: 'Cancel',
      acceptButton: 'Apply',
    }).afterClosed().subscribe((newValue: string) => {
      if (newValue) {
        this.currentDebitNote.tax = Number.parseFloat(newValue);
      } else {
        console.log('No change');
      }
    });
  }

  enterNewValueDialog(row: any, attr: string) {
    this._dialogService.openPrompt({
      message: 'Enter new value',
      viewContainerRef: this._viewContainerRef,
      title: 'Modify value',
      value: row[attr],
      cancelButton: 'Cancel',
      acceptButton: 'Apply',
    }).afterClosed().subscribe((newValue: string) => {
      if (newValue) {
        row[attr] = newValue;

      } else {
        console.log('DECLINED');
      }
    });
  }

  processEditDebitNote(orderNumber: string): Observable<DebitNote> {
    this.title = 'Edit';
    this.isEditMode = true;
    return this._salesService.getOneDebitNote(orderNumber);
  }

  processNewDebitNote(): Observable<DebitNote> {
    this.title = 'New';
    this.isEditMode = false;
    return Observable.of(new DebitNote());
  }

  validate(): boolean {

    // check that required fields are provided
    if (!this.currentDebitNote.order_date || !this.currentDebitNote.delivery_date || !this.currentDebitNote.type) {
      this._dialogService.openAlert({
        title: 'Missing Data',
        message: "Please Enter a Type (Debit or Credit), Order Date and Delivery Date",
        closeButton: 'OK'
      })

      return false;
    }

    // check that an invoice number is included
    if (this.currentDebitNote.status == 'SHIPPED' && !this.currentDebitNote.invoice_number) {

      this._dialogService.openAlert({
        message: 'Must provide an Invoice Number when setting  the Debit Note to SHIPPED!',
        title: 'Warning!',
      });

      return false;
    }

    // check that total is positive
    if (this.total() <= 0) {
      this._dialogService.openAlert({
        message: 'The total amount must be positive!',
        title: 'Warning!',
      });

      return false;
    }

    return true;
  }


  createNewDebitNote() {

    this.setLoading(true, 'loading');

    // validate before creating
    if (!this.validate()) {
      this.setLoading(false, 'loading');
      return;
    }

    // Clean slate
    this.currentDebitNote.items = [];
    this.items.forEach(
      (item) => {
        this.currentDebitNote.items.push({
          description: item.description,
          price: item.price
        });
      }
    );

    // Create the dn
    this._salesService.createDebitNote(this.currentDebitNote).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.currentDebitNote.id = response['id'];
          this.currentDebitNote.order_number = response['order_number'];

          this.originalDebitNote = Object.assign({}, this.currentDebitNote);

          if (this.need_invoice && this.currentDebitNote.status == 'SHIPPED') {
            this.createInvoice();
          }

          this.isEditMode = true;
          this._dialogService.openAlert({
            message: 'Debit Note ' + this.currentDebitNote.order_number + ' created successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {

            this.router.navigate(['/debitnotes', 'list']);
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not create Debit Note ' + this.currentDebitNote.order_number + '.',
            title: 'Failed!',
          });
        }
        this.setLoading(false, 'loading');

      },
      error => {
        this._dialogService.openAlert({
          message: 'Error creating Debit Note ' + this.currentDebitNote.order_number + ': ' + error,
          title: 'Error!',
        });
        this.setLoading(false, 'loading');

      },
      () => { }
    );
  }

  updateDebitNote() {

    this.setLoading(true, 'loading');

    // validate before creating
    if (!this.validate()) {
      this.setLoading(false, 'loading');
      return;
    }


    // Clean slate
    this.currentDebitNote.items = [];
    this.items.forEach(
      (item) => {
        this.currentDebitNote.items.push({
          description: item.description,
          price: item.price
        });
      }
    );

    this._salesService.updateDebitNote(this.currentDebitNote.id, this.currentDebitNote).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          if (this.need_invoice && this.currentDebitNote.status == 'SHIPPED') {
            this.createInvoice();
          }

          this._dialogService.openAlert({
            message: 'Debit Note ' + this.currentDebitNote.order_number + ' updated successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {

            this.originalDebitNote = Object.assign({}, this.currentDebitNote);

            this.router.navigate(['/debitnotes', 'list']);
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not update Debit Note ' + this.currentDebitNote.order_number + '.',
            title: 'Failed!',
          });
        }

        this.setLoading(false, 'loading');
      },
      error => {
        this._dialogService.openAlert({
          message: 'Error updating Debit Note ' + this.currentDebitNote.order_number + ': ' + error,
          title: 'Error!',
        });
        this.setLoading(false, 'loading');

      },
      () => { }
    );
  }

  createInvoice() {

    this.setLoading(true, 'invoice');

    let total = this.total() * (1 + (this.currentDebitNote.tax / 100));

    this._invoiceService.createInvoice(
      this.currentDebitNote.customer_id,
      this.currentDebitNote.branch_id,
      this.currentDebitNote.delivery_date,
      this.currentDebitNote.type == 'Debit' ? 'Invoice' : 'Credit',
      this.currentDebitNote.type == 'Debit' ? total : -total,
      this.currentDebitNote.invoice_number)

      .subscribe(
        response => {

          this._dialogService.openAlert({
            title: 'Success',
            message: 'Invoice ' + this.currentDebitNote.invoice_number + ' created.',
            closeButton: 'OK'
          });

          this.setLoading(false, 'invoice');
        },

        error => {
          this._dialogService.openAlert({
            title: 'Error!',
            message: 'Unable to create invoice ' + this.currentDebitNote.invoice_number + '.',
            closeButton: 'OK'
          });

          this.setLoading(false, 'invoice');
        }
      )

  }

  getAvailableStatuses(): string[] {
    // On new entry only DRAFT
    if (this.isEditMode == false) {
      return ['DRAFT', 'SHIPPED'];
    }

    switch (this.currentDebitNote.status) {
      // If it was draft, can be DRAFT, RESERVED
      case 'DRAFT':
        return ['DRAFT', 'SHIPPED'];

      // Else you can't move status in here
      default:
        return [this.currentDebitNote.status];
    }

  }

  goBack(): void {
    this.location.back();
  }

  isDraft(): boolean {
    if (this.currentDebitNote == null) return false;

    return true;
  }

  getPrefixForCustomerId(id: number) {
    this.currentDebitNote.customer_prefix = this.allCustomers.find(
      (c) => {
        return Number.parseInt(c.id) == id;
      }
    )['prefix'];

  }

  isShipped(): boolean {
    if (this.currentDebitNote == null) return false;

    switch (this.currentDebitNote.status) {
      case 'SHIPPED':
        return true;
      default:
        return false;
    }
  }

  isDeclined(): boolean {
    if (this.currentDebitNote == null) return false;

    switch (this.currentDebitNote.status) {
      case 'DECLINED':
        return true;
      default:
        return false;
    }
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/sales/debit-note/debit-note.component.ts